var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.521 6h3.043c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.52 1.522H5.52A1.518 1.518 0 014 7.52C4 6.678 4.678 6 5.521 6zm0 8.114h7.1c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.521 1.522h-7.1A1.518 1.518 0 014 15.635c0-.843.678-1.521 1.521-1.521zm0 8.114h11.157c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.521 1.522H5.521A1.518 1.518 0 014 23.749c0-.843.678-1.521 1.521-1.521zm0 8.114h15.214c.843 0 1.521.678 1.521 1.521 0 .843-.678 1.522-1.521 1.522H5.521A1.518 1.518 0 014 31.863c0-.843.678-1.521 1.521-1.521z"
  })));
}
export default SvgSortAscLeft;